import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import messages from './messages';
import Label from '../../../../components/Label';
import Form from '../../../../components/Form';

const ErrorLabel = (
  <Label
    role="tooltip"
    basic
    color="red"
    pointing
  ><FormattedMessage {...messages.studentFacultyRatioInvalidError} />
  </Label>
);

const StudentFacultyRatio = ({ onChange, initialValue, formatMessage }) => (
  <Form.Field>
    <Form.Input
      type="number"
      min="0"
      fluid
      placeholder={formatMessage(messages.studentFacultyRatio)}
      value={initialValue.value}
      data-cy="premium-Hem-Student-Faculty-Ratio-Input"
      onChange={(e, { value }) => {
        onChange(e, { value });
      }}
      error={initialValue.showError}
    />
    {initialValue.showError && ErrorLabel}
  </Form.Field>
);

StudentFacultyRatio.propTypes = {
  initialValue: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
};

export default StudentFacultyRatio;
